import type { FunctionComponent } from 'react';
import { isFeatureEnabled } from '../../../../../../helpers/features';
import { DISABLE_REPORT_UI_REFRESH } from '../../../../../../../shared/featureFlags/flagNames';
import { InvalidPermissionError } from '../../../../../settings/Errors';

/**
 * Displays an error message if the DISABLE_REPORT_UI_REFRESH feature flag is enabled.
 */
const FeatureGate: FunctionComponent = ({ children }) => {
  const isReportUIRefreshEnabled = !isFeatureEnabled(DISABLE_REPORT_UI_REFRESH);

  if (!isReportUIRefreshEnabled) {
    return (
      <div className="panel margin-xl">
        <InvalidPermissionError />
      </div>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default FeatureGate;
